import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { CustomHorizontalChart } from '../../../components/CustomHorizontalChart'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleMediumWidget } from '../DashboardSlice'
import { MoneyValue } from '../MoneyValue'
import { MediumWidgetsName } from '../types'
import { WidgetWrapper } from '../widgetsComponents'

export const AvgWinnerLoser: FC = () => {
  const { t } = useTranslation()
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()

  const { widgetsData, mediumWidgetsList } = useAppSelector(({ dashboard }) => dashboard)
  const { currentAccount } = useAppSelector(({ userAccounts }) => userAccounts)

  const currency = currentAccount?.currency as string
  const winner = widgetsData?.averageWinnerLooser?.winner
    ? Number(widgetsData.averageWinnerLooser.winner)
    : 0
  const loss = widgetsData?.averageWinnerLooser?.looser
    ? Number(widgetsData.averageWinnerLooser.looser)
    : 0

  const handleCheck = () => {
    dispatch(toggleMediumWidget(MediumWidgetsName.avgWinnerLoser))
  }

  return (
    <WidgetWrapper
      label={t('avgWinnerLoser', 'Avg winner/loser')}
      handleCheck={handleCheck}
      isChecked={mediumWidgetsList[MediumWidgetsName.avgWinnerLoser]}
      explanation={t(
        'avgWinnerLoserExplanation',
        'Represents the average amount of money a trader earns per winning trade, while the average loser represents the average amount of money a trader loses per losing trade',
      )}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        gap={spacing(1.5)}
        width="100%"
        justifyContent="center"
      >
        <MoneyValue money={winner} currency={currency} bigFont />
        <CustomHorizontalChart positive={winner} negative={loss} />
        <MoneyValue money={loss} currency={currency} bigFont />
      </Box>
    </WidgetWrapper>
  )
}
